import React, { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

import "../styles/contact.css";

import zaloMascot from "../assets/images/zaloMascot.png";
import iconPhone from "../assets/images/iconPhone.png";
import iconEmail from "../assets/images/iconEmail.png";
import iconMap from "../assets/images/iconMap.png";

const Contact = () => {
  /* ---------- STATE ---------- */
  const [phone, setPhone] = useState("");
  const [isValidPhone, setIsValidPhone] = useState(null);
  const [sending, setSending] = useState(false);
  const { t, i18n } = useTranslation(); // Thêm useTranslation

  /* ---------- HANDLERS ---------- */
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9+]/g, ""); // chỉ cho số & +
    setPhone(value);
    setIsValidPhone(/^[+0-9]{10,15}$/.test(value));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValidPhone) {
      Swal.fire("Lỗi!", "Số điện thoại không hợp lệ!", "error");
      return;
    }

    setSending(true);
    const formData = new FormData(e.target);
    formData.append("access_key", "4e01e6fb-87cb-47f8-9526-7e761edc4d43");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    setSending(false);
    if (data.success) {
      Swal.fire("Thành công!", "Đã gửi tin nhắn!", "success");
      e.target.reset();
      setPhone("");
      setIsValidPhone(null);
    } else {
      Swal.fire("Lỗi!", "Không gửi được tin nhắn!", "error");
    }
  };


  return (
    <div className="contact-page">
      {/* ---------- BANNER ---------- */}
      <section className="contact-banner">
        <div className="banner-text">
          <h1>{t("contact_with_us")}</h1>
          <h1>{t("contact_with_us_1")}</h1>
          <p>
            {t("contact_forward_from_you")} <br />
            {t("contact_us_by_phone")}
          </p>
        </div>
        <Link to="zalo://conversation?phone=+84345611645" className="contact-banner-img" target="_blank">
          <img src={zaloMascot} alt="Zalo" className="mascot-zalo" />
        </Link>
      </section>

      {/* ---------- MAIN CONTENT ---------- */}
      <section className="contact-content container">
        {/* ---- INFO BOX ---- */}
        <div className="contact-info">
          <div className="contact-box">
            <h5>
              <img src={iconMap} alt="" /> {t("contact_address")}
            </h5>
            <p>
              {t("contact_address_1")}
              <br />
              {t("contact_address_2")}
            </p>
          </div>
          <div className="contact-box">
            <h5>
              <img src={iconPhone} alt="" /> {t("contact_hotline")}
            </h5>
            <p>+84 941 604 103</p>
          </div>
          <div className="contact-box">
            <h5>
              <img src={iconEmail} alt="" /> Email
            </h5>
            <p>online@markandmilk.com</p>
          </div>
        </div>

        {/* ---- FORM ---- */}
        <div className="contact-form">
          <p className="form-subtitle">
            {t("contact_if_question")}
          </p>
          {/* <h2>SEND US A MESSAGE</h2> */}

          <form onSubmit={onSubmit}>
            <div className="form-row">
              <input type="text" name="name" placeholder={t("contact_your_name")} required />
              <input type="email" name="email" placeholder="Email" required />
            </div>

            <div className="form-row">
              <input
                type="tel"
                name="phone"
                placeholder={t("contact_phone")}
                value={phone}
                onChange={handlePhoneChange}
                required
                className={isValidPhone === false ? "invalid" : ""}
              />
              <input type="text" name="subject" placeholder={t("contact_subject")}/>
            </div>

            <textarea
              name="message"
              placeholder={t("contact_content_mess")}
              rows="5"
              required
            />

            <button type="submit" className="submit-btn" disabled={sending}>
              {sending ? t("contact_sending") : t("contact_send")}
            </button>
          </form>
        </div>
      </section>

      {/* ---------- GOOGLE MAP ---------- */}
      {/* <section className="map-container mt-5">
        <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
          <GoogleMap mapContainerStyle={mapStyle} center={center} zoom={16}>
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </section> */}
    </div>
  );
};

export default Contact;
